export const GET_UNDERCUT_LIST = 'GET_UNDERCUT_LIST';
export const GET_UNDERCUT_LIST_SUCCESS = 'GET_UNDERCUT_LIST_SUCCESS';
export const GET_UNDERCUT_LIST_FAIL = 'GET_UNDERCUT_LIST_FAIL';

export const GET_UNDERCUT_CONFIRM_LIST = 'GET_UNDERCUT_CONFIRM_LIST';
export const GET_UNDERCUT_CONFIRM_LIST_SUCCESS = 'GET_UNDERCUT_CONFIRM_LIST_SUCCESS';
export const GET_UNDERCUT_CONFIRM_LIST_FAIL = 'GET_UNDERCUT_CONFIRM_LIST_FAIL';

export const CONFIRM_UNDERCUT = 'CONFIRM_UNDERCUT';
export const CONFIRM_UNDERCUT_SUCCESS = 'CONFIRM_UNDERCUT_SUCCESS';
export const CONFIRM_UNDERCUT_FAIL = 'CONFIRM_UNDERCUT_FAIL';

export const STORNO_UNDERCUT = 'STORNO_UNDERCUT';
export const STORNO_UNDERCUT_SUCCESS = 'STORNO_UNDERCUT_SUCCESS';
export const STORNO_UNDERCUT_FAIL = 'STORNO_UNDERCUT_FAIL';

export const GET_UNDERCUT_TYPES_LIST = 'GET_UNDERCUT_TYPES_LIST';
export const GET_UNDERCUT_TYPES_LIST_SUCCESS = 'GET_UNDERCUT_TYPES_LIST_SUCCESS';
export const GET_UNDERCUT_TYPES_LIST_FAIL = 'GET_UNDERCUT_TYPES_LIST_FAIL';

export const GET_UNDERCUT_OPERATION = 'GET_UNDERCUT_OPERATION';
export const GET_UNDERCUT_OPERATION_SUCCESS = 'GET_UNDERCUT_OPERATION_SUCCESS';
export const GET_UNDERCUT_OPERATION_FAIL = 'GET_UNDERCUT_OPERATION_FAIL';

export const SAVE_UNDERCUT = 'SAVE_UNDERCUT';
export const SAVE_UNDERCUT_SUCCESS = 'SAVE_UNDERCUT_SUCCESS';
export const SAVE_UNDERCUT_FAIL = 'SAVE_UNDERCUT_FAIL';

export const DELETE_UNDERCUT = 'DELETE_UNDERCUT';
export const DELETE_UNDERCUT_SUCCESS = 'DELETE_UNDERCUT_SUCCESS';
export const DELETE_UNDERCUT_FAIL = 'DELETE_UNDERCUT_FAIL';
